define( 'main', [
    'extends/Mazarine',
    'helpers/HandlebarsHelper',
    'config/ConfigManager',
    'components/loader/Loader',
    'application/ApplicationRouter',
    'specific/customloader/models/CustomLoaderModel',
    'specific/customloader/views/CustomLoaderView',
    'application/templates/oldbrowsertemplate'
], function ( Mazarine, HandlebarsHelper, config, Loader, ApplicationRouter, CustomLoaderModel, CustomLoaderView, oldBrowserTemplate ) {
    var oldBrowser = false;

    var bowser = Tools.bowser();

    if (bowser.msie && bowser.version < 8.0) {
        oldBrowser = true;
    }
    if (bowser.android && bowser.osversion.split(".")[0] < 4) {
        oldBrowser = true;
    }
    if (bowser.safari && bowser.version < 8.0) {
        oldBrowser = true;
    }
    if (bowser.chrome && !bowser.android && bowser.version < 38.0) {
        oldBrowser = true;
    }
    if (bowser.firefox && bowser.version < 34.0) {
        oldBrowser = true;
    }

    if (bowser.android) {
        var ua = navigator.userAgent.toLowerCase();
        var match = ua.match(/android\s([0-9\.]*)/);
        oldBrowser = match ? parseFloat( match[1] ) < 4.4 : false;
    }

    if( oldBrowser ){
        switch (config.locale) {
            case "zh_hk":
            case "zh_tw":
                tradOldBrowser = {
                    "text": "您的網路瀏覽器不支援本網頁。請更新至最新版本。"
                };
            break;
            case "zh_cn":
                tradOldBrowser = {
                    "text": "您的浏览器版本过旧，请更新至最新版本。"
                };
            break;
            case "en_int":
            case "en_us":
            case "ko_kr":
            case "ru_ru":
            case "hk_en":
            case "en_gb":
                tradOldBrowser = {
                    "text": "Your browser is obsolete.<br>To visit this site under optimal conditions, please upgrade to the latest version."
                };
            break;
            case "nl_be":
                tradOldBrowser = {
                    "text": "Uw navigator is niet meer aangepast.<br>Gelieve een update uit te voeren."
                };
            break;
            case "ja_jp":
                tradOldBrowser = {
                    "text": "サイトを正しく表示するために、ブラウザのバージョンを最新版にアップデートしてください。"
                };
            break;
            case "fr_fr":
            case "fr_be":
                tradOldBrowser = {
                    "text": "Votre navigateur est obsolète.<br>Pour visiter ce site dans les meilleures conditions, veuillez procéder à une mise à jour de votre navigateur."
                };
            break;
            case "pt_br":
                tradOldBrowser = {
                    "text": "Seu navegador está desatualizado.<br>Para otimizar sua visita a este site, por favor atualize-o para a última versão."
                };
            break;
            case "de_de":
                tradOldBrowser = {
                    "text": "Ihre Browser Version ist veraltet.<br>Für den Besuch dieser Website unter optimalen Bedingungen, aktualisieren Sie bitte Ihren Browser auf die neueste Version."
                };
            break;
            case "es_sam":
            case "es_es":
                tradOldBrowser = {
                    "text": "Su navegador está obsoleto.<br>Para visitar este sitio en las mejores condiciones, actualice su navegador."
                };
            break;
            case "it_it":
                tradOldBrowser = {
                    "text": "Il browser non è aggiornato.<br>Per una visualizzazione ottimale del sito, aggiornare a una versione più recente."
                };
            break;
            default:
                tradOldBrowser = {
                    "text": "Your browser is obsolete.<br>To visit this site under optimal conditions, please upgrade to the latest version."
                };
            break;
        }

        $('#wrapper').addClass('maz-old-browser');

        tradOldBrowser.assets_url = config.assets_url;

        $('#maz-dior-content').html(oldBrowserTemplate( tradOldBrowser ));

        if( config.deviceEnv === 'mobile' ) {
            // $('#maz-dior-content').height( $(window).height() - $('#ecrin-header').outerHeight());
        }else {
            $('#maz-dior-content').height( $(window).height());
        }

    }else {
        $( '#fb-root' ).remove();
        $( 'body' ).prepend( '<div id="fb-root"></div>' );

        if ('ontouchstart' in window || navigator.maxTouchPoints) {
            document.documentElement.className += " touch";
        } else {
            document.documentElement.className += " no-touch";
        }

        var datas = null;
        var applicationRouter = null;
        var sequences = [];

        var loaderModel = new CustomLoaderModel({
            "isMobile": config.deviceEnv === 'mobile',
            "loader-text": '#MAISONCHRISTIANDIOR',
            // "assets_url": config.assets_url,
            // "logoUrl": config.assets_url + 'images/loader-fragrance.png'
        });

        var loaderView = new CustomLoaderView({model: loaderModel});
        $('#maz-dior-content').addClass('maz-site-loading').prepend( loaderView.render().$el );
        // loaderView.afterRender();

        if( config.deviceEnv === 'mobile' ) {
            $( '#maz-dior-content' ).height( screen.height - $('#ecrin-header').outerHeight() );
        }

        var elem = document.createElement('canvas');
        config.isCanvasSupported = !!(elem.getContext && elem.getContext('2d'));

        Loader.initialize({
            "defaultView": false,
            "animationDuration": 3000,
            onAnimationStepCallback: function(percent) {
                loaderModel.set('percent', percent);
            },
            onAnimationCompleteCallback: function(percent) {
                TweenLite.to(loaderView.el, 0.2, {autoAlpha: 0, onComplete: function(){
                    $('body').addClass('maz-site-ready');
                    loaderView.$el.remove();
                    $('#maz-dior-content').removeClass('maz-site-loading');
                    if( config.deviceEnv === 'mobile' ) {
                        $('#maz-dior-content').css("height", "auto");
                    } else {
                        $('#maz-dior-content').css("height", "100%");
                    }
                }});

                if (applicationRouter) {
                    applicationRouter.onLoaderAnimationComplete();
                }
            }
        });

        Loader.addTask("Get datas", function(onEnded) {
            var datasUrl = config.assets_url + config.jsonPath.replace('{{locale}}', config.locale);


            var GlobalModel = Backbone.Model.extend({
                "url": datasUrl
            });

            new GlobalModel().fetch({
                success: function(model, response, options) {
                    _.extend(config, model.get('config'));
                    config.ws_quickbuy_product.mobile = config.ws_quickbuy_product.mobile.replace('{{assets_url}}', config.assets_url).replace('{{ws_root_url}}', config.ws_root_url).replace('{{locale}}', config.locale);
                    config.ws_quickbuy_product.desktop = config.ws_quickbuy_product.desktop.replace('{{assets_url}}', config.assets_url).replace('{{ws_root_url}}', config.ws_root_url).replace('{{locale}}', config.locale);

                    datas =  model.get('datas');

                    onEnded(100);
                },
                error: function(model, response, options) {
                    console.error("[main -> task Get datas] Can't fetch datas", model, response, options);
                }
            });
        }, 2, 1);

        Loader.addTask( "Preload Images", function ( onEnded ) {
            var preloadImages = [];

            var getImagesSrc = _.bind( function (item, index){
                if (_.isArray(item) || _.isObject(item)){
                    if(index !== "popins" ) {
                        _.each(item, getImagesSrc);
                    }

                    _.each(item, function(value, key) {
                        if ( config.deviceEnv !== "mobile"){
                            if ( key === "backgroundImage" || key === "titleSlideImage") {
                                if(_.isString(value)) {
                                    preloadImages.push( value);
                                }
                            }
                        } else {
                            if ( key === "backgroundMobileVertical" || key === "coverMobile") {
                                if(_.isString(value)) {
                                    preloadImages.push( value);
                                }
                            }
                        }

                        if ( key === "src" || key === "packshot" || key === "cover") {
                            if(_.isString(value)) {
                                preloadImages.push( value);
                            }
                        }

                    }, this);
                }
            }, this);

            _.each(datas, _.bind(getImagesSrc, this));

            preloadImages = _.compact( _.flatten( _.uniq( preloadImages ) ) );

            var nbImagesPreloaded = 0;

            if ( preloadImages.length === 0 ) {
                onEnded(100);
            }
            _.each(preloadImages, _.bind(function(src) {
                var img = new Image();

                img.onerror = _.bind( function(){
                    nbImagesPreloaded++;
                    onEnded( nbImagesPreloaded / preloadImages.length * 100 );
                }, this);

                img.onload = _.bind(function(e) {
                    if( e )
                        e.currentTarget.onload = null; // Remove listener to save memory

                    nbImagesPreloaded++;
                    // console.log( img.src );

                    onEnded( nbImagesPreloaded / preloadImages.length * 100 );
                }, this);

                setTimeout( function() {
                    img.src = config.assets_url + src;
                }, 40);
            }, this));
        }, 2, 1 );

        Loader.start(function(progress, taskLabel) {
            // console.log("[main -> Loader progress]", progress, taskLabel);

            if (progress === 100 && !Backbone.History.started) {
                if( /(Line)/g.test( navigator.userAgent ) ) {
                    $('html').removeClass('mmm-iphone');
                }

                HandlebarsHelper.initialize({ "config": {"assets_url": config.assets_url, "base_url": config.base_url}, "trad": datas.wording });

                applicationRouter = new ApplicationRouter({ "datas": datas, "config": config });
                Backbone.history.start();
            }
        });
    }
} );
